import { mapState } from 'vuex';

const adoptionMixin = {
  computed: {
    ...mapState({
      loadingTechs: (state) => state.adoption.loadingTechs,
      technicians: (state) => state.adoption.technicians,
      adoptionInstallFilters: (state) => state.adoption.adoptionInstallFilters,
    }),
  },
};

export default adoptionMixin;
